import { render, staticRenderFns } from "./weeklyPayments.vue?vue&type=template&id=23455f02&scoped=true&"
import script from "./weeklyPayments.vue?vue&type=script&lang=js&"
export * from "./weeklyPayments.vue?vue&type=script&lang=js&"
import style0 from "./weeklyPayments.vue?vue&type=style&index=0&id=23455f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23455f02",
  null
  
)

export default component.exports